"use strict";
import { isObject, isPrimitive } from "@fe/g-shared/es/primitive";
import isBuffer from "is-buffer";
export * from "@fe/g-shared/es/helper";
export * from "@fe/g-shared/es/primitive";
const { toString } = Object.prototype;
export { isBuffer };
export const isNonNullPrimitive = (val) => {
  if (val === null || val === void 0) {
    return false;
  }
  return isPrimitive(val);
};
export const isString = (val) => typeof val === "string";
export const isBigInt = (val) => typeof val === "bigint";
export const isNumber = (val) => typeof val === "number";
export const isBoolean = (val) => typeof val === "boolean";
export const isUndefined = (val) => typeof val === "undefined";
export const isDate = (val) => toString.call(val) === "[object Date]";
export const isFile = (val) => toString.call(val) === "[object File]";
export const isBlob = (val) => toString.call(val) === "[object Blob]";
export const isArray = (val) => toString.call(val) === "[object Array]";
export const isMap = (val) => toString.call(val) === "[object Map]";
export const isFunction = (val) => typeof val === "function";
export const isStream = (val) => isObject(val) && isFunction(val.pipe);
export const isArrayBuffer = (val) => toString.call(val) === "[object ArrayBuffer]";
export const isFormData = (val) => typeof FormData !== "undefined" && val instanceof FormData;
export const isURLSearchParams = (val) => typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
export const isArrayBufferView = (val) => {
  let result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val == null ? void 0 : val.buffer) && val.buffer instanceof ArrayBuffer;
  }
  return result;
};
export const isStandardBrowserEnv = () => {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
};
export const isHeaders = (headers) => toString.call(headers) === "[object Headers]";
export const isResponse = (val) => toString.call(val) === "[object Response]";
export const combineURLs = (baseURL, relativeURL) => {
  return relativeURL ? `${baseURL.replace(/\/+$/, "")}/${relativeURL.replace(/^\/+/, "")}` : baseURL;
};
export const queryFormat = (obj) => {
  return Object.entries(obj).map(
    ([key, value]) => value !== void 0 && `${key}=${encodeURIComponent(value)}`
  ).filter((item) => item).join("&");
};
export const addParams = (url, params = {}) => {
  const queryString = queryFormat(params);
  return queryString.length ? `${url}${url.includes("?") ? "&" : "?"}${queryString}` : url;
};
export const parseEmail = (email, suffixWithAtSymbol = false) => {
  if (!email) {
    return ["", ""];
  }
  const index = email.lastIndexOf("@");
  if (index < 0) {
    return [email, ""];
  }
  const prefix = email.slice(0, index);
  const suffix = email.slice(suffixWithAtSymbol ? index : index + 1);
  return [prefix, suffix];
};
export const arraySort = (array, oldIndex, newIndex) => {
  const list = [...array];
  if (oldIndex === newIndex) {
    return list;
  }
  const old = list[oldIndex];
  if (oldIndex > newIndex) {
    list.splice(newIndex, 0, old);
    list.splice(oldIndex + 1, 1);
  } else {
    list.splice(newIndex + 1, 0, old);
    list.splice(oldIndex, 1);
  }
  return list;
};
export const omitUndefined = (obj) => {
  const newObj = {};
  for (const key in obj) {
    if (obj[key] !== void 0) {
      newObj[key] = obj[key];
    }
  }
  if (Object.keys(newObj).length < 1) {
    return void 0;
  }
  return newObj;
};
//# sourceMappingURL=index.js.map
